import { render, staticRenderFns } from "./ResetPasswordCallback.vue?vue&type=template&id=fd148608&lang=pug"
import script from "./ResetPasswordCallback.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports